import type { IconData } from '@stacksjs/iconify-core'

export const basicUiLock: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 5v1H1v10h14V6h-2V5A5 5 0 0 0 3 5m7 1V5a2 2 0 1 0-4 0v1zm-.748 5a1.252 1.252 0 1 1-2.504 0a1.252 1.252 0 0 1 2.504 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiLock
